import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import SvgIcon from "@components/icon/svg";
import { updateUserFav } from "@shared/apis/user";
import { getProductQRCodeUrl } from "../../helpers";

class DetailHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserFav: props.isUserFav,
      favCount: props.productFavCount || 0,
      qrcodeUrl: "",
    };
    this.handleWeiboShare = this.handleWeiboShare.bind(this);
    this.handleFav = this.handleFav.bind(this);
  }

  componentDidMount() {
    this.setState({
      qrcodeUrl: getProductQRCodeUrl({
        productId: this.props.productId,
        utmParam: "utm_source=www&utm_campaign=xcxh&utm_content=share",
      }),
    });
  }

  getShareContent() {
    const { productCity, productTitle } = this.props;
    return `我在美团榛果民宿发现一家${productCity ? productCity + "的" : ""}民宿不错，来看看吧！${productTitle}`;
  }

  getSharePics() {
    const { productPics } = this.props;
    return (productPics || [])
      .map(v => v && v.mediaUrl)
      .filter(Boolean)
      .slice(0, 9)
      .join("||");
  }

  getShareUrl() {
    const l = window.location;
    return `https://www.zhenguo.com${l.pathname}?phx_wake_up_type=pc_share&phx_wake_up_source=weibo`;
  }

  handleWeiboShare(e) {
    const node = e.currentTarget;
    const weiboUid = "6190487617";
    node.href = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(
      this.getShareUrl()
    )}&title=${encodeURIComponent(this.getShareContent())}&ralateUid=${weiboUid}&pic=${encodeURIComponent(
      this.getSharePics()
    )}`;
  }

  handleFav(e) {
    const { productId } = this.props;
    const { isUserFav, favCount } = this.state;
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    e.preventDefault();
    updateUserFav(productId, !isUserFav).then(res => {
      if (res.body.status === 0) {
        this.setState({
          isUserFav: !isUserFav,
          favCount: favCount + (!isUserFav ? 1 : -1),
        });
      } else if (res.body.status === 401) {
        // TODO
        alert("请先登录");
      }
    });
  }

  render() {
    const { productId } = this.props;
    const { isUserFav, favCount } = this.state;

    const pwu = this.props.pwu || { type: "pc_share", source: "weixin" };
    return (
      <Fragment>
        <div className="product-toolbar">
          <ul className="list-inline">
            {favCount > 0 && <li>{favCount}人收藏</li>}
            <li>
              <button
                type="button"
                className="product-toolbar__icon product-toolbar__icon--fav"
                title={`${isUserFav ? "取消" : ""}收藏房源`}
                onClick={this.handleFav}
              >
                <SvgIcon
                  symbol={isUserFav ? require("@shared/icons/fav-fill.svg") : require("@shared/icons/fav.svg")}
                  size="lg"
                />
              </button>
            </li>
            <li>
              <a
                href="javascript:void(0);"
                className="product-toolbar__icon product-detail__shared-weibo"
                target="_blank"
                rel="noopener noreferrer"
                title="点击分享至微博"
                onClick={this.handleWeiboShare}
              >
                <img src={require("@shared/images/weibo@2x.png")} alt="" />
              </a>
            </li>
          </ul>
        </div>
        <div className="product-toolbar">
          <ul className="list-inline" id="J-toolbar-wx">
            <li>微信扫码9折订</li>
            <li>
              <button className="product-toolbar__icon product-toolbar__icon--wx" type="button">
                <img src={require("@shared/images/weixin@2x.png")} alt="扫一扫分享房源" />
              </button>
              <div className="product-toolbar__qrcode">
                <img src={this.state.qrcodeUrl} alt="房源二维码" />
              </div>
            </li>
          </ul>
        </div>
      </Fragment>
    );
  }
}

DetailHeader.defaultProps = {
  isUserFav: false,
};

DetailHeader.propTypes = {
  isUserFav: PropTypes.bool,
  productCity: PropTypes.string,
  productTitle: PropTypes.string,
  productId: PropTypes.number,
  productFavCount: PropTypes.number,
  productPics: PropTypes.array,
  pwu: PropTypes.object,
};

export default DetailHeader;

require("./toolbar.less");
require("./index.less");